export enum CHARGE_TYPE {
  manual = 'manual',
}

export enum RECORD_TYPE {
  transaction = 'Transaction',
  charge = 'Charge',
  balance = 'OpeningBalance',
}
